export const TRANSLATION_SCOPE = 'pdfFormModule';
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
